export default __webpack_public_path__ + "static/media/applebadge.2e842790.svg";